import { Channel, ChannelType } from "types/working-model";

export function isBrandTVChannel(value?: Channel['type']): boolean {
	return value === ChannelType.BrandTV;
}

export function isWebinarChannel(value?: Channel['type']): boolean {
	return value === ChannelType.Webinar;
}
